import React from 'react';
import { useCompliance } from '../contexts/ComplianceContext';
import CryptoComplianceBanner from './CryptoComplianceBanner';

const ComplianceWrapper = ({ children }) => {
  const { showComplianceBanner, acceptRisk, declineRisk } = useCompliance();

  return (
    <>
      <CryptoComplianceBanner 
        onAccept={acceptRisk} 
        onDecline={declineRisk}
        show={showComplianceBanner}
      />
      {children}
    </>
  );
};

export default ComplianceWrapper;
